import { useState } from 'react';
import { message, notification } from 'antd';
import { importStudents } from '../../../services/importService';
import { StudentImportResult } from '../../../types/importTypes';

export function useStudentImport() {
  const [open, setOpen] = useState(false);
  const [csvFile, setCsvFile] = useState<File | null>(null);
  const [loading, setLoading] = useState(false);
  const [importResult, setImportResult] = useState<StudentImportResult | null>(null);

  const handleUpload = (file: File) => {
    setCsvFile(file);
    return false;
  };

  const handleSubmit = async (t: any) => {
    if (!csvFile) return;
    setLoading(true);

    try {
      const result = await importStudents({ file: csvFile });
      setImportResult(result);
      message.success(t('import_success_message'));
    } catch {
      message.error(t('import_error_message'));
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setCsvFile(null);
    setImportResult(null);
  };

  return {
    open,
    setOpen,
    csvFile,
    setCsvFile,
    loading,
    importResult,
    handleUpload,
    handleSubmit,
    reset,
  };
}
